import { appAxios } from "app/tools/axios/axios";

import { ApplicationVersion } from "../../entity";

export const readVersion = async (): Promise<ApplicationVersion> => {
  const response = await appAxios.get("version");
  return response.data.version;
};
